import { ChangeDetectorRef, Component, DoCheck, OnInit, ViewChild } from '@angular/core';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { ModalConfig, ModalOption } from '@shared/components/modal/modal.interface';
import { PageInfoService, PageLink } from '@metronic/layout';
import { BaseService } from '@services/base-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilitiesService } from '@services/utilities.service';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { BehaviorSubject } from 'rxjs';
import { API } from '@config/constants/api.constant';
import { IResetPassword, IResponseApprovalRetail, IRetailerDetail } from '@models/retailer.model';
import { ICardDetailBody, ICardProfileBody } from '@models/card.model';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { getDetailRetailer, getDetailRetailerPIC, getDetailVenture, getDocument, getLabelList } from '../retailer.data';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RetailerService } from '../retailer.service';
import { RetailerStatus, SubMenu } from '../enum/submenu.enum';
import { IDisplayConfidentialDocument, IListReject, IListRejectReason } from '../../distributor/interfaces/distributor.interface';
import { AuthService } from '@services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IDataInputQR } from '../retailers.interface';
import { CustomsSnackbarComponent } from '@shared/components/customs-snackbar/customs-snackbar.component';
import { ModalFormComponent } from '@shared/components/modal/modal-form/modal-form.component';
import { ModalNonActiveCustomerComponent } from '@shared/components/modal/modal-non-active-customer/modal-non-active-customer.component';
import { IGenericNameUrl } from '@shared/interface/generic';
import { IGmapData } from '@services/google-maps-config.service';
import { ICardLogConfig, ILogContext, ILogRecord, isRetailerLog } from '@shared/interface/log.interface';

@Component({
  selector: 'app-detail-legacy',
  templateUrl: './detail-legacy.component.html',
  styleUrls: ['./detail-legacy.component.scss'],
})
export class DetailLegacyComponent implements OnInit, DoCheck {
  modalConfig: ModalConfig = {
    modalTitle: 'Tambah User',
    closeButtonLabel: 'Batal',
    dismissButtonLabel: 'Setujui',
  };
  modalConfigResponse: ModalConfig = {
    detailButtonLabel: 'Lihat Detail',
    dismissButtonLabel: 'Oke',
    hideCloseButton(): boolean {
      return true;
    },
  };
  modalConfigReject: ModalConfig = {
    modalTitle: 'TOLAK RETAILER',
    closeButtonLabel: 'Batal',
    dismissButtonLabel: 'Tolak',
    color: 'danger',
    showFooter: true,
    disableDismissButton: () => (this.optionOtherSelected() && !this.rejectReasonValue) || !this.formIsValidToSubmit,
    onClose: () => {
      this.formReject.reset();
      return true;
    },
  };

  modalConfigResponseApprove: ModalConfig = {
    detailButtonLabel: 'Lihat Detail',
    dismissButtonLabel: 'Oke',
    hideCloseButton: () => true,
  };

  modalConfirmResetConfig: ModalConfig = {
    modalTitle: 'RESET PASSWORD RETAILER',
    closeButtonLabel: 'Cancel',
    dismissButtonLabel: 'Reset Password',
  };

  modalResponseResetConfig: ModalConfig = {
    detailButtonLabel: 'Lihat Detail',
    dismissButtonLabel: 'Oke',
    hideCloseButton(): boolean {
      return true;
    },
  };

  modalOptionResponseApprove: ModalOption = {
    size: 'md',
  };

  iconSuccess = STRING_CONSTANTS.ICON.SUCCESS_ALERT;
  iconCopy = STRING_CONSTANTS.ICON.IC_COPY;
  iconInfo = STRING_CONSTANTS.ICON.IC_INFORMATION_GREY;

  retailerStatusEnum = RetailerStatus;
  links: Array<PageLink>;
  id: any | null = null;
  responseApproval: IResponseApprovalRetail;

  listRejectEnum: BehaviorSubject<IListReject[]> = new BehaviorSubject<IListReject[]>([]);
  status: string | null = '';
  tab: string | null = '';
  detailView: string | null = 'default';
  listReasonReject: IListRejectReason[];
  listReasonNonactive: string[];
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  detail: BehaviorSubject<IRetailerDetail> = new BehaviorSubject<IRetailerDetail>({} as IRetailerDetail);
  documentNonactive: BehaviorSubject<IGenericNameUrl[]> = new BehaviorSubject<IGenericNameUrl[]>([]);

  labelList: ICardProfileBody[];
  detailRetailer: ICardDetailBody[];
  detailRetailerPIC: ICardDetailBody[];
  detailDocument: ICardDetailBody[];
  detailVenture: ICardDetailBody[];

  responseResetPassword: BehaviorSubject<IResetPassword | undefined> = new BehaviorSubject<IResetPassword | undefined>(undefined);
  parentMenu: string = 'RETAILER';

  keyDetailPrivilege: string = 'DETAIL_RETAILER';
  privilegeCta: BehaviorSubject<boolean[]> = new BehaviorSubject<boolean[]>([]);
  privilegeTabs: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  privilegeConfidentialDocuments: BehaviorSubject<any> = new BehaviorSubject<any>([]);

  displayTabs: string[] = ['TAB_RETAILER_INFORMATION', 'TAB_RETAILER_DOCUMENT']; /* all display tabs on this page */
  displayConfidentialDocuments: IDisplayConfidentialDocument[];
  ownerKtpUpdate: { key: string; value: string | null }[];

  _apiDetailRetailer = [
    { view: 'edit-request', url: API.DETAIL_RETAILER_SUBMISSION },
    { view: 'log', url: API.DETAIL_RETAILER_LOG },
    { view: 'default', url: API.DETAIL_RETAILER },
  ];

  formReject: FormGroup = this.fb.group({
    reject_enum: new FormArray([]),
    reject_reason: new FormControl(),
  });

  formIsValidToSubmit = false;

  logConfig!: ICardLogConfig;
  logContext!: ILogContext;

  @ViewChild('modalConfirm') private modalConfirmComponent: ModalComponent;
  @ViewChild('modalResponseAfterApprove') private modalResponseAfterApprove: ModalComponent;
  @ViewChild('modalResponseAfterReject') private modalResponseAfterReject: ModalComponent;
  @ViewChild('modalReject') private modalReject: ModalComponent;
  @ViewChild('modalAfterApprove') private modalAfterApprove: ModalComponent;
  @ViewChild('modalConfirmReset') private modalConfirmResetComponent: ModalComponent;
  @ViewChild('modalResetPassword') private modalResetPasswordSuccess: ModalComponent;
  @ViewChild('modalNonActiveCustomer') private modalNonActiveCustomer: ModalNonActiveCustomerComponent;
  @ViewChild('modalInputQR') private modalInputQR: ModalFormComponent;
  modalInputQRConfig: ModalConfig = {
    modalTitle: 'INPUT QR MANUAL',
    closeButtonLabel: 'Close',
    dismissButtonLabel: 'Submit',
    disableDismissButton: () => this.formInputQr.invalid,
    onClose: () => {
      this.clearInputQr();
      return true;
    },
  };

  formInputQr = this.fb.group({
    qr_code: ['', [Validators.required, Validators.maxLength(9), Validators.minLength(9)]],
  });
  audioResponse!: HTMLAudioElement;

  get qrCodeInput() {
    return this.formInputQr.get('qr_code');
  }

  get rejectEnumValue() {
    return this.formReject.value.reject_enum;
  }

  get rejectReasonValue() {
    return this.formReject.value.reject_reason;
  }

  // todo: remove unused - refactor

  constructor(
    private pageInfoService: PageInfoService,
    private baseService: BaseService,
    private router: Router,
    public utilities: UtilitiesService,
    private activatedRoute: ActivatedRoute,
    private ref: ChangeDetectorRef,
    private fb: FormBuilder,
    private rolePrivilegeService: RolePrivilegeService,
    private retailerService: RetailerService,
    private authService: AuthService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.id = params.get('id');
      this.status = params.get('status');
      this.tab = params.get('tab');
      this.detailView = params.get('view');
    });

    if (this.status?.toUpperCase() === this.retailerStatusEnum.pending) {
      this.getListReject().then((data) => this.initFormReject(data));
    }

    if (this.id) {
      this.getDetailInfo();
      this.initPageInfo();
      this.initLogConfig();
    }

    this.handlePrivilege();
  }

  handlePrivilege() {
    this.privilegeConfidentialDocuments.next(this.rolePrivilegeService.checkPrivilegeConfidential(this.parentMenu, this.keyDetailPrivilege, 'TAB_RETAILER_DOCUMENT'));

    const _enumPrivilegeCta = ['CTA_APPROVAL_RETAILER', 'CTA_REJECT_RETAILER', 'CTA_RESET_PASSWORD', 'CTA_NONACTIVATED_RETAILER'];
    const _tempCtaPrivilege: boolean[] = [];

    _enumPrivilegeCta.map((_enum) => {
      const _check = this.rolePrivilegeService.checkPrivilege(this.parentMenu, this.keyDetailPrivilege, _enum);
      _tempCtaPrivilege.push(_check);
    });

    this.privilegeCta.next(_tempCtaPrivilege);
    this.privilegeTabs.next(this.rolePrivilegeService.checkPrivilegeTabs(this.parentMenu, this.keyDetailPrivilege, this.displayTabs));
  }

  ngDoCheck() {
    const titleModalReject = this.detailView === 'edit-request' ? 'TOLAK PEMBARUAN DATA RETAILER' : 'TOLAK RETAILER';

    if (this.detailView === 'edit-request') {
      this.modalConfig = {
        ...this.modalConfig,
        showFooter: true,
        modalTitle: 'SETUJUI PEMBARUAN DATA RETAILER',
      };
    }

    this.modalConfigReject = {
      ...this.modalConfigReject,
      modalTitle: titleModalReject,
      showFooter: true,
    };
  }

  getDetailInfo() {
    const _getApi = this._apiDetailRetailer.find((val) => {
      return this.detailView && val.view === this.detailView;
    });

    const apiDetail = _getApi?.url ?? API.DETAIL_RETAILER;
    this.retailerService.getDetailByApi(this.id, apiDetail).subscribe((resp) => {
      if (!resp) return;

      const { data } = resp;
      this.detail.next(data);
      const document: IGenericNameUrl[] = [data.document_non_active];
      this.documentNonactive.next(document);
      if (this.status?.toUpperCase() === this.retailerStatusEnum.reject) {
        this.listReasonReject = data.retailer_rejection;
      }
      this.listReasonNonactive = data.non_active_reason;
      this.isLoading.next(false);
    });
  }

  getFormattedDate(val: string) {
    return this.utilities.timeStampToDate(val, 'dd MMMM yyyy');
  }

  getStatusRetailerTerverifikasi() {
    return this.detail.value.status_value;
  }

  generateLabelList() {
    if (!this.detail.value) return;

    this.labelList = getLabelList(this.detail.value);
    const { date_established, area_name, sub_area_name } = this.detail.value;

    const _dateEstablished = this.getFormattedDate(date_established);
    const _established = {
      icon: './assets/media/icons/ic_calendar.svg',
      value: 'Bergabung sejak ' + _dateEstablished,
    };

    const _location = {
      icon: STRING_CONSTANTS.ICON.IC_LOCATION,
      value: area_name + ', ' + sub_area_name,
    };

    this.labelList.push(_established, _location);
  }

  generateProfileRetailer() {
    if (!this.detail.value) return;
    this.detailRetailer = getDetailRetailer(this.detail.value);
  }

  generateVentureInformation() {
    if (!this.detail.value) return;
    this.detailVenture = getDetailVenture(this.detail.value);
  }

  generateBreadcrumbs(value: IRetailerDetail) {
    this.links = [
      {
        title: 'Retailer',
        path: '',
        isActive: false,
      },
      {
        title: '',
        path: '',
        isActive: false,
        isSeparator: true,
      },
      {
        title: this.utilities.SubMenuBreadcrumbTitles(this.status, SubMenu) ?? 'Retailer',
        path: this.getPathBreadcrumb(),
        isActive: false,
      },
      {
        title: '',
        path: '',
        isActive: false,
        isSeparator: true,
      },
    ];

    let _addBreadcrumb: any;
    if (this.detailView === 'log') {
      _addBreadcrumb = [
        {
          title: value?.venture_name,
          path: '/retailer/detail/active/terverifikasi/' + this.id,
          isActive: false,
        },
        {
          title: '',
          path: '',
          isActive: false,
          isSeparator: true,
        },
        {
          title: 'Detail Log',
          path: '',
          isActive: true,
        },
      ];
      _addBreadcrumb.map((val: any) => this.links.push(val));
    } else {
      _addBreadcrumb = {
        title: this.utilities.toCapitalize(value?.venture_name),
        path: '',
        isActive: true,
      };
      this.links.push(_addBreadcrumb);
    }

    this.pageInfoService.updateBreadcrumbs(this.links);
  }

  initPageInfo() {
    this.pageInfoService.updateTitle('Detail Retailer', undefined, true);
    if (this.detailView === 'log') this.pageInfoService.updateTitle('Detail Log', undefined, true);

    this.detail.subscribe((value) => {
      if (value) {
        this.generateBreadcrumbs(value);
        this.generateLabelList();
        this.generateProfileRetailer();
        this.generateVentureInformation();

        this.detailRetailerPIC = value.pic_marketing && getDetailRetailerPIC(value.pic_marketing);
        this.displayConfidentialDocuments = getDocument(value);

        if ((this.status?.toUpperCase() === this.retailerStatusEnum.pending && this.detailView !== 'default') || this.detailView === 'log') {
          if (Object.keys(value).length === 0) return;
          const _dataKtp = { key: 'old', value: value.owner_ktp_image_url ?? null };
          this.detailRetailer = this.utilities.generateUpdateValue(this.detailRetailer, value.detail_retailer_new);
          this.detailVenture = this.utilities.generateUpdateValue(this.detailVenture, value.detail_retailer_new);

          this.ownerKtpUpdate = this.utilities.generateSideDocument('owner_ktp_image_url', value.detail_retailer_new, _dataKtp);

          this.displayConfidentialDocuments = this.utilities.generateUpdateValue(this.displayConfidentialDocuments, value.detail_retailer_new);
          this.displayConfidentialDocuments.shift();
        } else {
          const _dataKtp = [{ key: 'old', value: value.owner_ktp_image_url ?? null }];
          this.ownerKtpUpdate = _dataKtp;
        }

        this.detailDocument = this.utilities.privilegeConfidentialDocuments(this.privilegeConfidentialDocuments.value, this.displayConfidentialDocuments);
      }
    });
  }

  initFormReject(data: BehaviorSubject<IListReject[]>) {
    data.subscribe((resp) => {
      this.formReject = this.fb.group({
        reject_enum: this.fb.array(resp.map(() => new FormControl(false))),
        reject_reason: new FormControl(''),
      });
    });
  }

  getPathBreadcrumb() {
    if (this.status?.toUpperCase() === this.retailerStatusEnum.reject) {
      return `retailer/${this.status}`;
    } else {
      return `retailer/${this.status}/${this.tab}`;
    }
  }

  async getListReject() {
    this.retailerService.getRetailerRejectionEnum(this.id).subscribe((resp) => {
      if (!resp) return;
      this.listRejectEnum.next(resp && resp.data);
    });

    return this.listRejectEnum;
  }

  handleApprove = () => this.modalConfirmComponent.open();

  submitForm = () => {
    const data = {
      reason: this.rejectReasonValue,
      retailer_reject_enum_list: this.getSelectedRejectValue(),
    };
    const apiApproval = this.detailView === 'edit-request' ? API.APPROVAL_RETAILER_SUBMISSION : API.APPROVAL_RETAILER;

    this.baseService.putData<IResponseApprovalRetail>(apiApproval + this.id, data).subscribe((response) => {
      if (response) {
        this.responseApproval = response.data;
        if (this.responseApproval) {
          this.ref.detectChanges();
          if (response.data.password) {
            this.modalResponseAfterApprove.open().then();
          } else {
            this.modalResponseAfterReject.open().then();
          }
        }
      }
    });
  };

  optionOtherSelected(): boolean {
    const _lastIndex = this.rejectEnumValue.length - 1;

    if (this.rejectEnumValue[_lastIndex] === false) {
      const _rejectReasonControl = this.formReject.get('reject_reason') as FormControl;
      _rejectReasonControl.reset();
    }

    return this.rejectEnumValue[_lastIndex];
  }

  closeModalResponse = () => {
    this.router.navigate(['/retailer/pending/register']).then();
  };

  handleReject() {
    this.isValidToSubmit();
    this.modalReject.open().then();
  }

  copyToClipboard(first: string = '', second: string = '') {
    let data: string = '';
    if (first && second) {
      data = first + '\n' + second;
    } else {
      data = first ? first : second;
    }
    navigator.clipboard.writeText(data).then();
  }

  closeModalResponseAfterApprove = () => {
    this.router.navigate(['/retailer/pending/register']).then();
    this.modalResponseAfterApprove.close().then();
  };

  toDetail = () => {
    this.router.navigate(['/retailer/detail/active/terverifikasi/' + this.id]).then(() => this.utilities.reloadPage());
  };

  toDetailReject = () => {
    this.router.navigate(['/retailer/reject/' + this.id]).then(() => this.utilities.reloadPage());
  };

  // RESET PASSWORD
  submitResetPassword = () => {
    this.modalConfirmResetComponent.close().then();
    this.resetPassword(this.detail.value?.account_id ?? '');
  };

  resetPassword = (id: string) => {
    if (id) {
      this.baseService.patchData<IResetPassword>(API.RESET_PASSWORD_RETAILER + id).subscribe((response) => {
        if (response) {
          this.responseResetPassword.next(response.data);
          this.ref.detectChanges();
          if (this.responseResetPassword) {
            this.ref.detectChanges();
            this.modalResetPasswordSuccess.open().then();
            this.ref.detectChanges();
          }
        }
      });
    }
  };

  closeModalResponseResetPassword = () => {
    this.modalResetPasswordSuccess.close().then();
  };

  clickResetPassword() {
    this.modalConfirmResetComponent.open().then();
  }

  chekInHasNewValue() {
    const _result = !!this.displayConfidentialDocuments?.filter((val) => val.new).length;
    return this.utilities.checkInHasNewValue(_result);
  }

  getSelectedRejectValue() {
    const listRejectEnum = this.listRejectEnum.value;
    return this.rejectEnumValue.map((checked: boolean, index: number) => (checked ? listRejectEnum[index].enum_value : null)).filter((item: any) => item !== null);
  }

  isValidToSubmit() {
    this.formReject.get('reject_enum')?.valueChanges.subscribe((_v: any) => {
      this.formIsValidToSubmit = _v.includes(true);
    });
  }

  retailerIsMac() {
    if (!this.detail.value) return;
    const { is_mac } = this.detail.value;
    return is_mac;
  }

  ableToRegisterMAC() {
    if (!this.detail.value) return;
    const { can_register_mac } = this.detail.value;
    return can_register_mac;
  }

  getBadge() {
    let _badge = '';

    if (!this.detail.value) {
      return _badge;
    }

    const { is_mac } = this.detail.value;
    _badge = is_mac ? STRING_CONSTANTS.ICON.IC_BADGE_MAC : '';
    return _badge;
  }

  getMacInfo() {
    if (!this.detail.value) {
      return [];
    }

    const { mac_scope, mac_code } = this.detail.value;
    let { register_mac_date } = this.detail.value;
    register_mac_date = this.utilities.timeStampToDate(register_mac_date, 'dd MMM yyyy');

    return this.retailerService.generateMacInfo({ mac_scope, register_mac_date, mac_code } as IRetailerDetail);
  }

  registerMAC() {
    const { id, status } = this.activatedRoute.snapshot.params;
    return this.retailerService.goToMACRegistration(id, status);
  }

  generateMapData(isFor: 'owner' | 'venture', isNewData = false) {
    if (!this.detail.value) return;

    const {
      owner_latitude,
      owner_longitude,
      owner_name,
      owner_district,
      owner_regency,
      owner_province,
      venture_latitude,
      venture_longitude,
      venture_name,
      venture_district,
      venture_regency,
      venture_province,
    } = isNewData ? this.detail.value.detail_retailer_new : this.detail.value;

    let _data: IGmapData = { lat: 0, lng: 0, label: '', description: '' };
    _data =
      isFor === 'owner'
        ? {
            lat: isFinite(owner_latitude) ? owner_latitude : 0,
            lng: isFinite(owner_longitude) ? owner_longitude : 0,
            label: owner_name,
            description: `${owner_district}, ${owner_regency}, ${owner_province}`,
          }
        : {
            lat: isFinite(venture_latitude) ? venture_latitude : 0,
            lng: isFinite(venture_longitude) ? venture_longitude : 0,
            label: venture_name,
            description: `${venture_district}, ${venture_regency}, ${venture_province}`,
          };

    return _data;
  }

  hasNewPinpoint(isOwner: boolean) {
    if (this.detailView !== 'edit-request' && this.detailView !== 'log') return false;
    return isOwner
      ? !!(this.detail.value?.detail_retailer_new?.owner_latitude && this.detail.value?.detail_retailer_new?.owner_longitude)
      : !!(this.detail.value?.detail_retailer_new?.venture_latitude && this.detail.value?.detail_retailer_new?.venture_longitude);
  }

  getRejectModalHeading() {
    if (!this.detail.value) return;
    const { status_value } = this.detail.value;
    return status_value === 'PENDING_REGISTRATION'
      ? 'Silahkan input alasan menolak registrasi retailer:'
      : status_value === 'PENDING_EDIT_VERIFICATION'
      ? 'Silahkan input alasan penolakan permintaan pembaruan data retailer:'
      : undefined;
  }

  hasDocumentPembaruanList() {
    if (!this.detail.value) return;
    const { document_pembaruan_list } = this.detail.value;
    return document_pembaruan_list && !!document_pembaruan_list.length;
  }

  //temp.check venture has new data
  ventureHasNewData() {
    if (!this.detail.value) return;
    const _hasNew = this.detailVenture.filter((item) => item.hasOwnProperty('new') && item.new !== null && item.new !== '');
    return !!_hasNew.length;
  }

  onSubmitInputQr() {
    this.isLoading.next(true);
    const _payload = this.formInputQr.value as IDataInputQR;

    this.retailerService.postRetailerQR(this.id, _payload).subscribe((resp) => {
      if (!resp) return;

      if (resp && !resp.success) {
        this.isLoading.next(false);

        if (resp.errors) this.showSnackBar(resp);
        else this.showSnackBar({ success: false, errors: [{ title: '', message: 'Something went wrong! Try again later' }] });

        return this.getSound(false);
      }

      this.showSnackBar(resp);
      this.isLoading.next(false);
      return this.getSound(resp.success);
    });

    return true;
  }

  async getSound(isSuccess: boolean) {
    this.audioResponse = new Audio(
      !isSuccess
        ? 'https://s3-ap-southeast-1.amazonaws.com/maxxi-staging/file/FILE_22b3a6a7-c203-4a20-92a2-ab1a24840665'
        : 'https://s3-ap-southeast-1.amazonaws.com/maxxi-staging/file/FILE_eb5b5414-ca11-4e30-b39f-5cb4330020c6'
    );

    if (isSuccess) this.clearInputQr();

    this.audioResponse.load();
    return this.audioResponse.play();
  }

  showSnackBar(res: any) {
    const { success, message } = res;
    const _msg = success ? message : res.errors[0].message ? res.errors[0].message : res.errors[0].title;
    this.snackBar.openFromComponent(CustomsSnackbarComponent, {
      duration: 3000,
      horizontalPosition: 'end',
      data: {
        color: success ? '#353535' : '#CC4435',
        text: _msg,
        icon: success ? STRING_CONSTANTS.ICON.IC_BULLET_TICK_WHITE : STRING_CONSTANTS.ICON.IC_FAIL_SCAN_PRODUCT,
      },
    });
  }

  clearInputQr = () => this.formInputQr.reset();

  isSuperAdmin = () => this.authService.isRoleSuperAdmin;

  initLogConfig() {
    this.logContext = {
      id: this.id,
      status: this.status as string,
      tab: this.tab as string,
      view: this.detailView,
    };

    this.logConfig = {
      urlDataApi: API.LIST_LOG_RETAILER + this.id,
      emptyStateText: 'Retailer belum memiliki riwayat perubahan',

      linkGenerator: (record: ILogRecord) => {
        if (!record || !isRetailerLog(record)) return null;
        if (!record.retailer_id || !(record.retailer_status_enum === 'PENDING_EDIT_VERIFICATION')) return null;
        return {
          url: `/retailer/detail/${this.status}/active/log/${record.retailer_id}`,
          label: 'Lihat Detail',
        };
      },

      reasonFormatter(record: ILogRecord) {
        if (!isRetailerLog(record)) return null;
        if (!record.reasons || record.reasons.length === 0) return null;
        return record.reasons.map((r) => r.enum_string).join(', ');
      },
    };
  }

  protected readonly API = API;
  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
  protected readonly RetailerStatus = RetailerStatus;
}
